import {
  SUPPORT_ADD_ATTACHMENT,
  SUPPORT_ADD_ATTACHMENT_SUCCESS,
  SUPPORT_ALL,
  SUPPORT_ALL_SUCCESS,
  SUPPORT_COMMENT,
  SUPPORT_COMMENT_SUCCESS,
  SUPPORT_CREATE,
  SUPPORT_CREATE_SUCCESS,
  SUPPORT_GET,
  SUPPORT_GET_ATTACHMENT,
  SUPPORT_GET_ATTACHMENT_SUCCESS,
  SUPPORT_GET_SUCCESS,
  SUPPORT_RESOLVE,
  SUPPORT_RESOLVE_SUCCESS,
} from 'redux/constants/Support';

export const getAllTickets = (perPage, page) => {
	return {
		type: SUPPORT_ALL,
		perPage,
		page,
	};
};

export const getAllTicketsSuccess = (tickets, total) => {
	return {
		type: SUPPORT_ALL_SUCCESS,
		tickets,
		total,
	};
};

export const getTicket = (id) => {
	return {
		type: SUPPORT_GET,
		id,
	};
};

export const getTicketSuccess = (ticket) => {
	return {
		type: SUPPORT_GET_SUCCESS,
		ticket,
	};
};

export const createTicket = (data, history) => {
	return {
		type: SUPPORT_CREATE,
		data,
		history,
	};
};

export const createTicketSuccess = (ticket) => {
	return {
		type: SUPPORT_CREATE_SUCCESS,
		ticket,
	};
};

export const resolveTicket = (id) => {
	return {
		type: SUPPORT_RESOLVE,
		id,
	};
};

export const resolveTicketSuccess = (ticket) => {
	return {
		type: SUPPORT_RESOLVE_SUCCESS,
		ticket,
	};
};

export const commentTicket = (id, comment) => {
	return {
		type: SUPPORT_COMMENT,
		id,
		comment,
	};
};

export const commentTicketSuccess = (ticket) => {
	return {
		type: SUPPORT_COMMENT_SUCCESS,
		ticket,
	};
};

export const getTicketAttachment = (id) => {
	return {
		type: SUPPORT_GET_ATTACHMENT,
		id,
	};
};

export const getTicketAttachmentSuccess = (attachment) => {
	return {
		type: SUPPORT_GET_ATTACHMENT_SUCCESS,
		attachment,
	};
};

export const addTicketAttachment = (id, attachment) => {
	return {
		type: SUPPORT_ADD_ATTACHMENT,
		id,
		attachment,
	};
};

export const addTicketAttachmentSuccess = (attachment) => {
	return {
		type: SUPPORT_ADD_ATTACHMENT_SUCCESS,
		attachment,
	};
};
